var map = {
	"./MPR.svg": "24a2",
	"./MPR_s.svg": "3260",
	"./arrowAnnotate.svg": "55c4",
	"./arrowAnnotate_s.svg": "a60f",
	"./back.svg": "c557",
	"./back2.svg": "6011",
	"./boy.svg": "b470",
	"./check.svg": "f75a",
	"./chuizhifanzhuan.svg": "984a",
	"./chuizhifanzhuan_s.svg": "5be2",
	"./d_cheXiao.svg": "585a",
	"./d_cheXiao_s.svg": "8b4d",
	"./d_fanZhuan.svg": "542c",
	"./d_fanZhuan_s.svg": "c9f1",
	"./d_fangDa.svg": "4b54",
	"./d_fangDa_s.svg": "4015",
	"./d_liangDu.svg": "765e",
	"./d_liangDu_s.svg": "f86c",
	"./d_yiDong.svg": "6016",
	"./d_yiDong_s.svg": "ab56",
	"./d_you.svg": "6d5d",
	"./d_you_s.svg": "7f82",
	"./d_zuo.svg": "3c52",
	"./d_zuo_s.svg": "e735",
	"./down.svg": "d681",
	"./fanye.svg": "bbb3",
	"./fanye_s.svg": "d66e",
	"./freehandRoi.svg": "a606",
	"./freehandRoi_s.svg": "989c",
	"./girl.svg": "4600",
	"./jiaopian-s.svg": "4b07",
	"./jiaopian.svg": "84b6",
	"./lineMarkerTool.svg": "fc26",
	"./lineMarkerTool_s.svg": "664c",
	"./next_page.svg": "c5576",
	"./nishizhen.svg": "15fb",
	"./nishizhen_s.svg": "d3c7",
	"./pre_page.svg": "7ea7",
	"./probe.svg": "7975",
	"./probe_s.svg": "5dbc",
	"./share.svg": "5306",
	"./shuipingfanzhuan.svg": "d1d0",
	"./shuipingfanzhuan_s.svg": "135b",
	"./shunshizhen.svg": "501c",
	"./shunshizhen_s.svg": "545d",
	"./textMarker.svg": "0b41",
	"./textMarker_s.svg": "fb97",
	"./title_bg.svg": "8d67",
	"./tuwen-s.svg": "c236",
	"./tuwen.svg": "25f9",
	"./up.svg": "1380",
	"./ver_info.svg": "dd44",
	"./warn.svg": "f809",
	"./xiazai.svg": "982d",
	"./xiazai_s.svg": "9b75",
	"./y_1.svg": "16fe",
	"./y_1_s.svg": "a642",
	"./y_2_h.svg": "38d3",
	"./y_2_h_s.svg": "c66f",
	"./y_2_l.svg": "f91c",
	"./y_2_l_s.svg": "2dc0",
	"./y_3.svg": "97e5",
	"./y_3_s.svg": "707a",
	"./y_4.svg": "6ae0",
	"./y_4_s.svg": "fab2",
	"./y_6.svg": "6100",
	"./y_6_s.svg": "a26f",
	"./y_boFang.svg": "5368",
	"./y_boFang_s.svg": "59e6",
	"./y_ceLiang.svg": "2fef",
	"./y_ceLiang_s.svg": "dd0e",
	"./y_fanSe.svg": "e0d0",
	"./y_fanSe_s.svg": "e966",
	"./y_gongJu.svg": "3f11",
	"./y_gongJu_s.svg": "ba7b",
	"./y_huanYuan.svg": "61d5",
	"./y_jiaoDu.svg": "b596",
	"./y_jiaoDu_s.svg": "9eee",
	"./y_juXing.svg": "98db",
	"./y_juXing_s.svg": "8309",
	"./y_qingChu.svg": "511e",
	"./y_qingChu_s.svg": "88ad",
	"./y_tiaoChuang.svg": "bcde",
	"./y_tiaoChuang_s.svg": "ea96",
	"./y_tuoYuan.svg": "17f3",
	"./y_tuoYuan_s.svg": "d5d3",
	"./y_xuLie.svg": "8cdf",
	"./y_xuLie_s.svg": "3c91",
	"./y_yiDong.svg": "2f0e",
	"./y_yiDong_s.svg": "924b",
	"./y_zhiXian.svg": "ac61",
	"./y_zhiXian_s.svg": "cd1e",
	"./y_ziShiYing.svg": "db4d",
	"./y_ziShiYing_s.svg": "1d9f",
	"./yingxiang-s.svg": "b8b5",
	"./yingxiang.svg": "0407",
	"./zoom-in.svg": "2f8f",
	"./zoom-out.svg": "3d7c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";